/**
 * @fileoverview Translation hook - Wrapper for LanguageContext
 * Provides translation function using database-backed translations
 */
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Translation hook
 * Uses the existing LanguageContext that loads translations from database
 * @returns {Object} Translation utilities
 */
export const useTranslation = () => {
    const { t, currentLanguage, loading } = useLanguage();

    return { t, currentLanguage, loading };
};
